import type { OSCE } from '@ils/osces/db/osce.js';
import type { ExamSlotRatingDoc } from './rating.js';
import type { RatingConfig } from './ratingConfig.js';

export const calculateScoreOfRatingDoc = (
  osce: OSCE,
  ratingConfig: RatingConfig,
  ratingConfigName: string,
  ratingDoc: ExamSlotRatingDoc,
) => {
  let scoreSum = 0;
  for (const [index, category] of (osce.instructionCategories ?? []).entries()) {
    const categoryWeightMultiplier = ratingConfig.categoryWeights[index];
    if (!categoryWeightMultiplier)
      throw new Error(
        `category index '${index}' does not have a weight multiplier for ratingConfig ${ratingConfigName}`,
      );

    let count = 0;
    let sum = 0;
    for (const rating of ratingDoc.ratings) {
      if (!category.instructions.map(i => i._id).includes(rating.instructionId)) continue;
      const score = rating.score === -1 ? 0 : rating.score;
      count++;
      // normalize score from choice index 0 to ratingConfig.choices - 1 to range 0 to 1 before adding it to the total
      sum += score / (ratingConfig.choices - 1);
    }

    if (count === 0) continue;
    const average = sum / count;
    const weightedAverage = average * categoryWeightMultiplier;
    scoreSum += weightedAverage;
  }
  return scoreSum;
};
